
import { defineComponent, onMounted } from "vue";

export default defineComponent({
    emits: [ 'finished' ],
    props: { message: { type: String, required: true }, type: { type: String, default: 'info' } },
    setup({ message, type }, { emit }) {
        onMounted(() => setTimeout(() => emit('finished'), 3000));
        return { message, type };
    }
})
